module.exports = __webpack_public_path__ + "static/media/expert (5).3bd935db.png";